import 'react-toastify/dist/ReactToastify.css';
import './App.css';

import { ToastContainer, toast } from 'react-toastify';
import { Route, Routes } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { lazy, Suspense } from 'react';

import Loader from './components/miscellaneous/Loader';

const Navbar = lazy(() => import('./components/miscellaneous/Navbar'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const Footer = lazy(() => import('./components/miscellaneous/Footer'));
const TermsAndConditions = lazy(() => import('./pages/TermsAndConditions'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const ENach = lazy(() => import('./pages/ENach'));
const LoanApplicationTC = lazy(() => import('./pages/LoanApplicationTC'));
const RefundPolicy = lazy(() => import('./pages/RefundPolicy'));
const AccountAgg = lazy(() => import('./pages/AccountAgg'));
const ContactUs = lazy(() => import('./pages/ContactUs'));
const InstantLoan = lazy(() => import('./pages/InstantLoan'));
const ShortLoan = lazy(() => import('./pages/ShortLoan'));
const Home = lazy(() => import('./pages/Home'));
const RepayLoan = lazy(() => import('./pages/RepayLoan'));
const MakePayment = lazy(() => import('./pages/MakePayment'));
const PaymentReceived = lazy(() => import('./pages/PaymentReceived'));
const InstantJourney = lazy(() => import('./pages/InstantJourney'));
const ProtectedThankYou = lazy(() => import('./pages/ThankYou'));
const GrievanceRedressal = lazy(() => import('./pages/GrievanceRedressal'));
const DataStorageSharingPolicy = lazy(() => import('./pages/DataStorageSharingPolicy'));
const DigitalLendingPolicy = lazy(() => import('./pages/DigitalLendingPolicy'));
const FairPracticeCode = lazy(() => import('./pages/FairPracticeCode'));
const RecoveryPolicy = lazy(() => import('./pages/RecoveryPolicy'));
const ResponseHandler = lazy(() => import('./pages/ResponseHandler'));
const PayEmi = lazy(() => import('./pages/PayEmi'));
const APRTermsAndConditions = lazy(() => import('./pages/APRTermsAndConditions'));
const Netbanking = lazy(() => import('./pages/Netbanking'));
const RepayLoanWithoutOTP = lazy(() => import('./pages/RepayLoanWithoutOTP'));
const QuickLead = lazy(() =>  import('./pages/QuickLead'));
const QuickLeadThankYou = lazy(() => import('./pages/QuickLeadThankYou'));
const Iframe = lazy(() => import("./pages/Iframe"));
const RBICOR = lazy(() => import("./pages/RBICOR"));
const EMICalculator = lazy(() => import("./pages/EMICalculator"));
const CustomerDocUpload = lazy(() => import("./pages/CustomerDocUpload"));

const toastStyles = {
  error: {
    background: "red",
    color: "white",
  },
  success: {
    background: "green",
    color: "white"
  }
};
const customToast = {
  error: (message) =>
    toast.error(message, {
      style: toastStyles.error
    }),
  success: (message) =>
    toast.success(message, {
      style: toastStyles.success
    })
};

function App() {
  const location = useLocation();

  return (
    <div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      

      {
        location?.pathname.includes("/repay-loan") || location?.pathname.includes("/customer-doc-upload") ?
          <Routes>
            <Route path="/repay-loan" Component={RepayLoanWithoutOTP} /> {/*  http://localhost:3000/repay-loan?amount=1&loan_id=GFPLF00000000073 */}
            <Route path="/customer-doc-upload/:token/:docsId" Component={CustomerDocUpload} /> {/*  /customer-doc-upload/<token>/24|26|15|99 */}
            <Route path="/customer-doc-upload" Component={CustomerDocUpload} /> {/*  /customer-doc-upload?token=... */}
          </Routes> :
          <>
            <Suspense fallback={<Loader />}>
              <Navbar />
              
              <Routes>
                <Route path="/" Component={Home} />
                <Route path="/aboutus" Component={AboutUs} />
                <Route path="/repayLoan" Component={RepayLoan} />
                <Route path="/make-payment" Component={MakePayment} />
                <Route path="/payment-received" Component={PaymentReceived} />
                <Route path="/instant_loan" Component={InstantLoan} />
                <Route path="/short_loan" Component={ShortLoan} />
                <Route path="/t&c" Component={TermsAndConditions} />
                <Route path="/privacy_policy" Component={PrivacyPolicy} /> {/*  can be merged based on what to keep on app */}
                <Route path="/privacyPolicy" Component={PrivacyPolicy} />
                <Route path="/e-nach_t&c" Component={ENach} />
                <Route path="/loan_application_t&c" Component={LoanApplicationTC} />
                <Route path="/refund_policy" Component={RefundPolicy} />
                <Route path="/acc_agg" Component={AccountAgg} />
                <Route path="/contactus" Component={ContactUs} />
                <Route path="/emi-calculator" Component={EMICalculator} />
                <Route path="/instant-journey" Component={InstantJourney} />
                <Route path="/instant-journey/:journeyId" Component={InstantJourney} />
                <Route path='/thankyou' Component={ProtectedThankYou} />
                <Route path='/grievance-redressal' Component={GrievanceRedressal} />
                <Route path='/data-storage-sharing-policy' Component={DataStorageSharingPolicy} />
                <Route path='/digital-lending-policy' Component={DigitalLendingPolicy} />
                <Route path='/fair-practice-code' Component={FairPracticeCode} />
                <Route path='/recovery-policy' Component={RecoveryPolicy} />
                <Route path='/ccavResponseHandler' Component={ResponseHandler} />
                <Route path='/PayEmi' Component={PayEmi} />
                <Route path='/apr_t&c' Component={APRTermsAndConditions} />
                <Route path='/customer-banking' Component={Netbanking} />
                <Route path='/check_cibil_score' Component={lazy(() => import('./pages/CheckCibilScore'))} />
                {/* Keep diff routes for add campaign tracking */}
                <Route path='/quick_lead' Component={QuickLead} />
                <Route path="/quick_lead_thankyou" Component={QuickLeadThankYou} />
                <Route path='/fm_quick_lead' Component={QuickLead} />
                <Route path="/fm_quick_lead_thankyou" Component={QuickLeadThankYou} />
                {/* End of campaign tracking routes */}
                <Route path="/iframe" Component={Iframe} />
                <Route path='/rbi-cor' Component={RBICOR} />
              </Routes>
              <Footer />
            </Suspense>
          </>
      }
    </div>
  );
}

export { App as default, customToast };
